import { Box } from '@mui/material';
import { LabeledValue } from '~/components/Fields/LabeledValue';
import { Image3D } from '~/domain/patient/image3d';

export default function ImageExportDetails({ image }: { image: Image3D }) {
    return (
        <Box py={1} display="grid" gap={1}>
            <Box
                display="grid"
                gridTemplateColumns="minmax(0,2fr) minmax(0,2fr) minmax(0,1fr)"
                gap={1}
            >
                <LabeledValue
                    label="Name"
                    value={image.seriesMetadata.seriesDescription}
                />
                <LabeledValue
                    label="Generation Model"
                    value={image.generationModel?.label}
                />
                <LabeledValue label="Slices" value={image.length} />
            </Box>
        </Box>
    );
}
